module.exports = __webpack_public_path__ + "lp-pla2-physiology.47f29f3f5b52bb5bef5e0ab053292dde.png";